import type { MiddlewareAPI } from 'redux';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/concat';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import userBoardOwnerAccountId from '../../../services/user-board-owner-account-id/index.tsx';
import { fetchedBoardOwnerAccountId, type Action } from '../../../state/actions.tsx';
import {
	getBaseUrl,
	getLocationKey,
	getSelectedBoard,
	shouldLoadBoardOwnerAccountId,
} from '../../../state/selectors.tsx';
import type { State } from '../../../state/types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	store: MiddlewareAPI<State>,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	locationKeyConsumer$: (arg1: string) => any,
	onFailure: (arg1: string) => Action,
): Observable<Action> => {
	const state = store.getState();
	const baseUrl = getBaseUrl(state);
	const selectedBoard = getSelectedBoard(state);

	if (shouldLoadBoardOwnerAccountId(state)) {
		if (!selectedBoard) {
			return Observable.of(
				onFailure('Cannot fetch board owner account id if there is no selected board'),
			);
		}

		return Observable.fromPromise(userBoardOwnerAccountId(baseUrl, selectedBoard.id))
			.mergeMap((accountId) =>
				Observable.concat(
					Observable.of(fetchedBoardOwnerAccountId(accountId)),
					locationKeyConsumer$(accountId),
				),
			)
			.catch((error) => Observable.of(onFailure(error.message)));
	}

	const locationKey = getLocationKey(state);
	if (!locationKey) {
		return Observable.of(onFailure('Cannot find current location key'));
	}

	return locationKeyConsumer$(locationKey);
};
